'use client'

import React, { useState } from 'react'

import { KeyboardKey } from './keyboard-key'

interface KeyboardLayoutProps {
  onKeyPress?: (value: string) => void
  isNumeric?: boolean
}

const NumericLayout = ({
  onKeyPress,
}: {
  onKeyPress?: (value: string) => void
}) => (
  <div className="grid grid-cols-4 grid-rows-4 gap-1 overflow-hidden bg-gray-50 p-3">
    <div className="col-start-1 col-end-2 row-start-1 row-end-2">
      <KeyboardKey value="1" onClick={onKeyPress} className="h-full w-full" />
    </div>
    <div className="col-start-2 col-end-3 row-start-1 row-end-2">
      <KeyboardKey value="2" onClick={onKeyPress} className="h-full w-full" />
    </div>
    <div className="col-start-3 col-end-4 row-start-1 row-end-2">
      <KeyboardKey value="3" onClick={onKeyPress} className="h-full w-full" />
    </div>

    <div className="col-start-1 col-end-2 row-start-2 row-end-3">
      <KeyboardKey value="4" onClick={onKeyPress} className="h-full w-full" />
    </div>
    <div className="col-start-2 col-end-3 row-start-2 row-end-3">
      <KeyboardKey value="5" onClick={onKeyPress} className="h-full w-full" />
    </div>
    <div className="col-start-3 col-end-4 row-start-2 row-end-3">
      <KeyboardKey value="6" onClick={onKeyPress} className="h-full w-full" />
    </div>

    <div className="col-start-1 col-end-2 row-start-3 row-end-4">
      <KeyboardKey value="7" onClick={onKeyPress} className="h-full w-full" />
    </div>
    <div className="col-start-2 col-end-3 row-start-3 row-end-4">
      <KeyboardKey value="8" onClick={onKeyPress} className="h-full w-full" />
    </div>
    <div className="col-start-3 col-end-4 row-start-3 row-end-4">
      <KeyboardKey value="9" onClick={onKeyPress} className="h-full w-full" />
    </div>

    <div className="col-start-1 col-end-2 row-start-4 row-end-5">
      <KeyboardKey value="." onClick={onKeyPress} className="h-full w-full" />
    </div>
    <div className="col-start-2 col-end-3 row-start-4 row-end-5">
      <KeyboardKey value="0" onClick={onKeyPress} className="h-full w-full" />
    </div>

    <div className="col-start-3 col-end-5 row-start-4 row-end-5">
      <KeyboardKey value="⌫" onClick={onKeyPress} className="h-full w-full" />
    </div>

    <div className="col-start-4 col-end-5 row-start-1 row-end-4">
      <KeyboardKey value="+" onClick={onKeyPress} className="h-full w-full" />
    </div>
  </div>
)

const QwertyLayout = ({
  onKeyPress,
}: {
  onKeyPress?: (value: string) => void
}) => {
  const [showSpecialChars, setShowSpecialChars] = useState(false)

  const mainRows = [
    ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0', '-', '+', '⌫'],
    ['q', 'w', 'e', 'r', 't', 'y', 'u', 'i', 'o', 'p'],
    ['a', 's', 'd', 'f', 'g', 'h', 'j', 'k', 'l'],
    ['@', 'z', 'x', 'c', 'v', 'b', 'n', 'm', ',', '.', '/'],
  ]

  const specialRows = [
    ['@', '#', '$', '%', '&', '*', '(', ')', '-', '+'],
    ['!', '?', ',', '.', '/', ':', ';', '"', "'"],
  ]

  const rows = showSpecialChars ? specialRows : mainRows

  return (
    <div className="flex w-full flex-col gap-1 bg-gray-50 p-2">
      {rows.map((row, i) => (
        <div key={i} className="flex w-full justify-center gap-1">
          {row.map((key) => (
            <KeyboardKey
              key={key}
              value={key}
              onClick={onKeyPress}
              className="w-full capitalize"
            />
          ))}
        </div>
      ))}
      <div className="flex justify-center gap-1">
        <KeyboardKey value=" " onClick={onKeyPress} className="w-full" />
      </div>
    </div>
  )
}

const KeyboardLayout = ({
  onKeyPress,
  isNumeric = false,
}: KeyboardLayoutProps) => {
  return isNumeric ? (
    <NumericLayout onKeyPress={onKeyPress} />
  ) : (
    <QwertyLayout onKeyPress={onKeyPress} />
  )
}

export { KeyboardLayout }
